import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { Filter } from '@utp/react-components-prod';
import { WrapperFilter } from './styled';

const CustomFilter = ({ choices, label, onChange, placeholder }: any) => {
  const clickEvent = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false
  });

  const clickOutside = () => {
    const sbFilter = document.getElementsByClassName('sb-filter');
    if (sbFilter[0].classList.contains('sb-filter--open')) {
      document
        .getElementsByClassName('sb-filter__top')[0]
        .dispatchEvent(clickEvent);
    }
  };
  return (
    <WrapperFilter
      data-testid="cmp-custom-filter-custom"
      style={{ marginBottom: '16px' }}
    >
      <OutsideClickHandler onOutsideClick={clickOutside}>
        <Filter
          chips={false}
          choices={choices}
          label={label}
          onChange={onChange}
          placeholder={placeholder}
        />
      </OutsideClickHandler>
    </WrapperFilter>
  );
};

export default CustomFilter;
